module.exports = __webpack_public_path__ + "img/kiss-beam.25beab41.svg";